import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const links = [
  { label: 'Features', href: '#features' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Blog', href: '/blog' },
  { label: 'FAQ', href: '#faq' },
];

export default function Navbar() {
    const [s, setS] = React.useState(false);
    const [m, setM] = React.useState(false);
    const location = useLocation();
    React.useEffect(() => { const h = () => setS(window.scrollY > 50); window.addEventListener('scroll', h, { passive: true }); return () => window.removeEventListener('scroll', h); }, []);
    const go = (e, h) => { e.preventDefault(); setM(false); document.querySelector(h)?.scrollIntoView({ behavior: 'smooth' }); };
    const isBlogPage = location.pathname.startsWith('/blog');

  return (
    <motion.nav data-testid="navbar" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.1 }}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000, padding: '0 0',
        background: s ? 'rgba(9,9,11,0.85)' : 'transparent', backdropFilter: s ? 'blur(16px) saturate(180%)' : 'none',
        borderBottom: s ? '1px solid rgba(255,255,255,0.04)' : 'none', transition: 'all .6s cubic-bezier(.4,0,.2,1)',
      }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        <a href="#" onClick={e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} data-testid="nav-logo"
          style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontFamily: 'var(--heading)', fontWeight: 800, fontSize: 19, letterSpacing: '-0.03em', color: '#FAFAFA' }}>
            bonk<span style={{ color: '#FF5E3A' }}>.</span>
          </span>
        </a>

        <div className="nav-center" style={{ display: 'flex', alignItems: 'center', gap: 2, background: 'rgba(255,255,255,0.03)', borderRadius: 100, padding: '4px 6px', border: '1px solid rgba(255,255,255,0.04)' }}>
          {links.map(l => {
            if (l.href.startsWith('/')) {
              return <Link key={l.href} to={l.href} data-testid={`nav-link-${l.label.toLowerCase()}`}
                style={{ color: '#71717A', fontSize: 13, fontWeight: 500, padding: '6px 16px', borderRadius: 100, transition: 'color .2s, background .2s', textDecoration: 'none' }}
                onMouseEnter={e => { e.target.style.color = '#FAFAFA'; e.target.style.background = 'rgba(255,255,255,0.04)'; }}
                onMouseLeave={e => { e.target.style.color = '#71717A'; e.target.style.background = 'transparent'; }}
              >{l.label}</Link>;
            }
            return <a key={l.href} href={l.href} onClick={e => go(e, l.href)} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g,'-')}`}
              style={{ color: '#71717A', fontSize: 13, fontWeight: 500, padding: '6px 16px', borderRadius: 100, transition: 'color .2s, background .2s' }}
              onMouseEnter={e => { e.target.style.color = '#FAFAFA'; e.target.style.background = 'rgba(255,255,255,0.04)'; }}
              onMouseLeave={e => { e.target.style.color = '#71717A'; e.target.style.background = 'transparent'; }}
            >{l.label}</a>;
          })}
        </div>

        <a href="#cta" onClick={e => go(e, '#cta')} data-testid="nav-download-cta" className="nav-cta-d"
          style={{ color: '#FAFAFA', fontSize: 13, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4, transition: 'color .2s' }}
          onMouseEnter={e => e.currentTarget.style.color = '#FF5E3A'} onMouseLeave={e => e.currentTarget.style.color = '#FAFAFA'}
        >Download <ArrowUpRight size={14} /></a>

        <button data-testid="mobile-menu-btn" className="mob-btn" onClick={() => setM(!m)} style={{ color: '#FAFAFA', padding: 8 }}>
          <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.5">
            {m ? <path d="M16 4L4 16M4 4l12 12"/> : <path d="M3 7h14M3 13h14"/>}
          </svg>
        </button>
      </div>

      {m && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} style={{ background: 'rgba(9,9,11,0.98)', backdropFilter: 'blur(20px)', borderTop: '1px solid rgba(255,255,255,0.04)', padding: '20px 24px' }}>
          {links.map(l => {
            if (l.href.startsWith('/')) {
              return <Link key={l.href} to={l.href} onClick={() => setM(false)} data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                style={{ display: 'block', padding: '16px 0', color: '#A1A1AA', fontSize: 15, fontWeight: 500, borderBottom: '1px solid rgba(255,255,255,0.04)', textDecoration: 'none' }}
              >{l.label}</Link>;
            }
            return <a key={l.href} href={l.href} onClick={e => go(e, l.href)} data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g,'-')}`} style={{ display: 'block', padding: '16px 0', color: '#A1A1AA', fontSize: 15, fontWeight: 500, borderBottom: '1px solid rgba(255,255,255,0.04)' }}>{l.label}</a>;
          })}
          <a href="#cta" onClick={e => go(e, '#cta')} data-testid="mobile-nav-download" style={{ display: 'inline-block', marginTop: 16, color: '#FF5E3A', fontSize: 15, fontWeight: 600 }}>Download Bonk</a>
        </motion.div>
      )}
      <style>{`
        .nav-center{display:none}.nav-cta-d{display:none}.mob-btn{display:block}
        @media(min-width:768px){.nav-center{display:flex !important}.nav-cta-d{display:inline-flex !important}.mob-btn{display:none !important}}
      `}</style>
    </motion.nav>
  );
}
